import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from "../../../components/Box";
import { Content } from "../../../components/Content";

const Container = styled.div``;
const ErrorResponse = styled.div`
    color: red;
`;

const Warning = styled.div`
    color: red;
`;

const STATE = {
    amount: null,
    detailedCalculation: null,
    error: null,
};

/* eslint-disable react/prefer-stateless-function */
class BmpResultComp extends BaseComponent {
    constructor(props) {
        super(props, {
            ...STATE,
        });
    }

    get amount() {

        return this.props?.result?.amount;
    }

    get error() {

        return this.props?.result?.error;
    }

    get bpmRegime() {
        return this.props?.result?.bpmRegime;
    }

    get emissionMeasurement() {
        return this.props?.result?.emissionMeasurement;
    }

    get warnings() {
        return this.props?.result?.warnings ?? null;
    }

    get calculationSteps() {

        return this.props?.result?.detailedCalculation?.steps;
    }

    get appliedBpmRegime() {

        return this.bpmRegime + (this.emissionMeasurement ? ` (${this.emissionMeasurement})` : '');
    }

    componentDidMount() {
    }

    renderTotal() {

        return (
            this.amount !== null &&
            this.amount !== undefined &&
            <VBox>
                <h1>{this.lbl('tools.bpm.result.netBpmCalculation')}</h1>
                <h1>&euro; {this.amount}</h1>
            </VBox>
        );
    }

    renderAppliedRegime() {

        return (
            this.bpmRegime &&
            <Content>
                <VBox>
                    <p>{this.lbl('tools.bpm.detailedCalculation.appliedRegime')}</p>
                    <p>{this.appliedBpmRegime}</p>
                </VBox>
            </Content>
        );
    }

    renderWarnings() {

        return (
            this.warnings &&
            <div>
                {this.warnings.map(w => (
                    <Content key={w.name}>
                        <VBox>
                            <Warning>
                                <p>{w.name}</p>
                            </Warning>
                        </VBox>
                    </Content>
                ))}
            </div>
        );
    }

    renderDetailedCalculation() {

        return (
            this.calculationSteps &&
            <div>
                {this.calculationSteps.map(s => (
                    <Content key={s.name}>
                        <VBox>
                            <p>{this.lbl('tools.bpm.detailedCalculation.stepName.' + s.name)}</p>
                            <p>{s.description}</p>
                            <p><b>{s.calculation} = {s.result}</b></p>
                        </VBox>
                    </Content>
                ))}
            </div>
        );
    }

    renderError() {
        return (
            this.error ??
            <ErrorResponse><p>{this.error}</p></ErrorResponse>
        );
    }

    render() {

        return (
            <Container>
                {this.renderTotal()}
                {this.renderAppliedRegime()}
                {this.renderWarnings()}
                {this.renderDetailedCalculation()}
                {this.renderError()}
            </Container>
        );
    }
}

BmpResultComp.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
    createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatch,
    };
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export const BmpResult = compose(
    withConnect,
    withRouter,
)(BmpResultComp);
